import { FC } from 'react';
import { Else, If, Then, When } from 'react-if';
import Link from 'next/link';
import { useAuth } from '@zep/auth';
import { ZemColorIcon } from '@zep/icons';
import { getResizedImage } from '@zep/utils';
import { StoreCardProps } from '../../../../types/StoreTypes';
import S from './StoreAppCard.module.scss';
const StoreAppCard: FC<StoreCardProps> = ({
  item
}: StoreCardProps) => {
  const {
    user
  } = useAuth();
  if (!item) {
    return <></>;
  }
  return <Link className={S.app_card_wrapper} href={`/store/details?id=${item.hashId}`} prefetch={false} data-sentry-element="Link" data-sentry-component="StoreAppCard" data-sentry-source-file="StoreAppCard.tsx">
      <div className={S.app_card_thumbnail_wrapper}>
        <img className={S.app_img_thumbnail} src={getResizedImage(item.finalImageUrl, 44)} alt={item.name} loading={'lazy'} />
      </div>
      <div className={S.app_text}>
        <div className={S.app_summary}>
          <div className={S.app_title}>{item.name}</div>
          <When condition={item.shortDescription} data-sentry-element="When" data-sentry-source-file="StoreAppCard.tsx">
            <label className={S.app_description}>{item.shortDescription}</label>
          </When>
        </div>
        <When condition={!user?.isEdu} data-sentry-element="When" data-sentry-source-file="StoreAppCard.tsx">
          <label className={S.app_price}>
            <If condition={item?.price === 0} data-sentry-element="If" data-sentry-source-file="StoreAppCard.tsx">
              <Then data-sentry-element="Then" data-sentry-source-file="StoreAppCard.tsx">
                <>FREE</>
              </Then>
              <Else data-sentry-element="Else" data-sentry-source-file="StoreAppCard.tsx">
                <ZemColorIcon width={18} height={18} data-sentry-element="ZemColorIcon" data-sentry-source-file="StoreAppCard.tsx" />
                <span className={S.app_price_amount}>
                  {item?.price?.toLocaleString()}
                </span>
              </Else>
            </If>
          </label>
        </When>
      </div>
    </Link>;
};
export default StoreAppCard;